export default () => ({
  formConfig: {
    formValue: {
      shop_id: '', // 店铺id
      timerange: [], // 时间区间
      bill_no: '', // 退单单号
      orderId: ''
    },
    formData: [
      {
        // version: '1.3',
        style: 'dropSelect',
        width: '24',
        isActive: true,
        isdisabled: false,
        itemdata: {
          serviceId: 'r3-cp',
          colid: 167606,
          colname: 'CP_C_SHOP_ID', // 当前字段的名称
          fkdisplay: 'drp', // 外键关联类型
          fkdesc: t('店铺'), // 店铺
          inputname: 'CP_C_SHOP_ID', // 这个是做中文类型的模糊查询字段，例如ENAME
          isfk: true, // 是否有fk键
          isnotnull: true, // 是否必填
          name: t('平台店铺'), // 平台店铺
          readonly: false, // 是否可编辑，对应input   readonly属性
          valuedata: '' // 这个是选择的值
        },
        oneObj: (val) => {
          console.log(val);
        }
      },
      {
        style: 'date',
        label: t('平台修改时间'),
        value: 'timerange',
        type: 'datetimerange',
        width: '24',
        format: 'yyyy-MM-dd HH:mm:ss' // 时间格式
      },
      {
        style: 'input',
        label: t('平台售后单号'),
        value: 'bill_no',
        width: '24',
        icon: '', // 输入框后带的图标,暂只有输入框支持
        placeholder: '',
        ghost: false, // 是否关闭幽灵按钮，默认开启
        inputenter: () => { }, // 表单回车事件
        iconclick: () => { } // 点击icon图标事件
      },
      {
        style: 'input',
        label: t('平台单号'), // 平台单号
        value: 'orderId',
        width: '24',
        ghost: false, // 是否关闭幽灵按钮，默认开启
      },
    ]
  },
  init: (self) => {
    $utils.formEmpty(self, 'downLoadFormConfig')
  },
  // 确定按钮
  determine: async (self) => {
    if (!self.downLoadFormConfig.formData[0].itemdata.pid) {
      self.$Message.warning(t('请选择需要下载的平台店铺！'));// 请选择需要下载的平台店铺
      return false;
    }
    /* if (
      self.downLoadFormConfig.formValue.bill_no === ''
      && self.downLoadFormConfig.formValue.timerange[0] === '' && self.downLoadFormConfig.formValue.timerange[1] === ''
    ) {
      self.$Message.warning(t('退单修改时间和退单单号不能同时为空'));// 退单修改时间和退单单号不能同时为空
      return false;
    } */
    const params = {
      orderId: self.downLoadFormConfig.formValue.orderId,
      shop_id: self.downLoadFormConfig.formData[0].itemdata.pid,
      bill_no: self.downLoadFormConfig.formValue.bill_no,
      start_time: self.downLoadFormConfig.formValue.timerange[0] ? $utils.standardTimeConversiondateToStr(self.downLoadFormConfig.formValue.timerange[0]) : undefined,
      end_time: self.downLoadFormConfig.formValue.timerange[1] ? $utils.standardTimeConversiondateToStr(self.downLoadFormConfig.formValue.timerange[1]) : undefined,
      table: 'IP_B_PLATFORM_RETURN_ORDER'
    };
    const fromdata = new FormData();
    fromdata.append('param', JSON.stringify(params));

    const { data: { code, message } } = await self.service.orderCenter.returnOrderDownload(fromdata);
    if (code === 0) {
      self.$Message.success(message);
      self.$emit('closeActionDialog', true);
    }
  }
});
